import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageHeader } from '../../providers/PageHeaderProvider';
import { usePageTitle } from '../../hooks/usePageTitle';
import { VendorsContent } from '../../components/billing/vendors/VendorsContent';

const STATE_FILTER_STORAGE_KEY = 'fv_billing_vendorStateFilter';

export function VendorsList() {
    usePageTitle('Vendors');
    const { setTitle, setSubtitle } = usePageHeader();
    const navigate = useNavigate();
    // The open drawer is URL-driven, so links are shareable and the browser
    // back button restores it.
    const { vendorId } = useParams<{ vendorId: string }>();
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        setTitle('Vendors');
        setSubtitle(`${totalCount} total`);
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [totalCount, setTitle, setSubtitle]);

    return (
        <VendorsContent
            openVendorId={vendorId ?? null}
            onOpenVendor={(id) => navigate(`/billing/vendors/${id}`)}
            onCloseVendor={() => navigate('/billing/vendors')}
            stateFilterStorageKey={STATE_FILTER_STORAGE_KEY}
            onTotalCountChange={setTotalCount}
        />
    );
}
